var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingsAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.35988C2 3.15613 2.12015 2.97149 2.30658 2.88874C4.97629 1.70375 8.0237 1.70375 10.6934 2.88874C10.8798 2.97149 11 3.15613 11 3.35988V21.0013C11 21.5529 10.5523 22 9.99999 22H3C2.44771 22 2 21.5529 2 21.0013V3.35988Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22H12.292C12.4258 21.6942 12.5 21.3564 12.5 21.0013V11.0144H20C21.1046 11.0144 22 11.9086 22 13.0118V20.0026C22 21.1057 21.1046 22 20 22H19V19.0039C19 17.9008 18.1046 17.0065 17 17.0065C15.8954 17.0065 15 17.9008 15 19.0039V22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsAlt4);
export default __webpack_public_path__ + "static/media/buildings-alt-4.1b478fde1527ddce4c313ca76c6ed73f.svg";
export { ForwardRef as ReactComponent };